import slice from './oldBuilderSlice';
import { setBuilderFunnelModeThunk } from './thunks';

export * from './types';
export default slice.reducer;

export const {
  // Cohorts related start
  setCohortRowSimpleTypeKey,
  setCohortRowSubject,
  setCohortRowAnalysis,
  setCohortRowTimeWindow,
  setCohortRowTimeWindowValues,
  setCohortRowOperator,
  setCohortRowOperatorValues,
  setCohortRowReturnedOperator,
  setCohortRowDatePicker,
  setCohortRowDateRange,
  setCohortRowPercentileFilter,
  setCohortRowDurationStartDate,
  setCohortRowLookForwardWindow,
  addCohortRow,
  removeCohortRow,
  resetCohortRow,
  addSimpleCohort,
  // Cohorts related end
  addBuilderNegativeStep,
  addEventValuesAction,
  addNewEventAction,
  addNewRowAction,
  setBuilderSchemaId,
  builderPathSetDirectionAction,
  builderSetRollingControl,
  expandNamedFilterAction,
  convertVirtualToBasicEventAction,
  populateReportData,
  removeEventRowAction,
  removeRowAction,
  removeSelectedPartitionAction,
  replaceFilterAction,
  replaceVirtualEvent,
  resetFunnelOrder,
  setAttributionAction,
  setBuilderCustomOrderAction,
  setBuilderFunctionAction,
  setBuilderFunnelModeAction,
  setCohortRowTimeToConvertOperatorValues,
  setCohortRowTimeToConvertOperator,
  setCohortRowTimeToConvertTimeUnit,
  setMeasureFiltersAction,
  resetMeasureFiltersAction,
  setBuilderOrderAction,
  setBuilderPathModeAction,
  setBuilderTimeWindowAction,
  setCalculationAction,
  setCalculationWindowAction,
  builderSetSamplingRate,
  setCustomTimeBracketAction,
  setDateKindAction,
  setErrorAction,
  setEventPropertyAction,
  setExpandEventAction,
  setFunctionPercentileAction,
  setMergeEventAlias,
  setGroupbyAction,
  setRetentionViewAction,
  setRowPropAction,
  setSelectedPartitionAction,
  timeWindowSetAction,
  addCachedCohort,
  builderSetCohortSampleOperation,
  builderSetCohortSamplingRate,
  removeErrorAction,
  builderPopulateCohortAnalysis,
  populateNamedCohortReference,
  populateNamedBuilderCohort,
  setBuilderAdditionalSettings,
  setSubjectAction,
  setTriggerSubjectAction,
  setExpressionModeAction,
  swapDataTableMeasure,
  swapFunnelStep,
  swapQueryMeasure,
  addMeasureCohortFilter,
  addExpandEventAction,
  addFoldEventAction,
  addMergeEventAction,
  removeReroutingEventAction,
  resetSegments,
  setFilterAction,
  addBreakdownGroup,
  removeBreakdownGroup,
  changeBreakdownOrder,
  toggleBreakdownOverall,
  setBreakdownGroupField,
  setBreakdownGroupFilter,
  setBreakdownGroupBinning,
  resetBreakdownGroups,
  addMeasureFormula,
  removeMeasureFormula,
  setMeasureFormulaExpression,
  dataTableMeasureSetNamedMeasure,
  queryMeasureSetNamedMeasure,
  populateCachedCohort,
  showStepPartition,
  setStepPartition,
  populateNextStep,
  setComparisonConfig,
  setSignificanceMode,
  setSignificanceMetricType,
  setSignificanceMeasureMetric,
  setSignificanceFunnelReport,
  setSignificanceFunnelStep,
  setSignificanceFunnelTimeToConvertMetric,
  setSignificanceQueryReport,
  setSignificanceRetentionReport,
  setSignificanceTestType,
  setSignificanceLevel,
  setSignificanceConfidenceLevel,
  setSignificanceBreakdownField,
  removeSignificanceCriteriaVariant,
  setSignificanceErrors,
  setSignificanceExperimentId,
  setSignificanceControlGroup,
  setSignificanceVariant,
  setCohortRowSamplePercentage,
  setActiveCohortUnit,
  setActiveRetentionUnit,
  setTimeUnit,
  setMissingDatesConfig,
  setSelectedBinning,
  removeBinning,
  setSelectedDateInput,
  populateConfig,
  restoreInitialConfig,
  resetBuilder,
  setBuilderInitialized,
  builderToggleShowLumosPrompt,
} = slice.actions;

export { setBuilderFunnelModeThunk };
